import $ from 'jquery';
import UIkit from 'uikit';

$('.js-wow-slide-banner-b').each(function() {
  const $bar = $('.js-wow-slide-banner-b__loading-bar', this);
  const slideshow = UIkit.slideshow(this);
  
  if(slideshow.autoplay) {
    const $line = $('<div class="js-wow-slide-banner-b__loading-bar-line"></div>')
    $bar.html($line);
    
    UIkit.util.on(this, 'itemshown', () => {
      $line.css('transition-duration', (slideshow.autoplayInterval - slideshow.duration) + 'ms');
      $(this).addClass('js-wow-slide-banner-b__loading-bar-run');
    });
    UIkit.util.on(this, 'beforeitemshow', () => {
      $(this).removeClass('js-wow-slide-banner-b__loading-bar-run');
    });
  }
  
});